import { Button, Input, Modal, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { fetchSpocUser, getCentralUserCenters, updateDashboardUser } from '../../services/api/hospitalDashboard';

const DashboardUserEditModal = ({
    id,
    updates,
    onClose,
    onComplete
}) => {

    const [isLoading, setIsLoading] = useState(false)
    const [isSpocLoading, setIsSpocLoading] = useState(false)
    const [newUpdates, setNewUpdates] = useState(updates)
    const [spocUsers, setSpocUsers] = useState([])

    const getSpocUser = (search) => {
        if (search.length) {
            setIsSpocLoading(true)
            fetchSpocUser(search)
                .then((res) => {
                    setSpocUsers(res.body.data.map(item => ({
                        value: item.id,
                        label: item.name
                    })))
                })
                .finally(() => {
                    setIsSpocLoading(false)
                })
        }
    }

    useEffect(() => {
        setNewUpdates(updates)
        if (updates && updates.role === 'central') {
            getCentralUserCenters(id)
                .then((response) => {
                    if (response.status === 200) {
                        console.log(response.data.data)
                        const centerIds = response.data.data || []
                        setNewUpdates(u => ({
                            ...u,
                            network_center_id: [
                                ...new Set([
                                    u.network_center_id,
                                    ...centerIds
                                ])
                            ].join(',')
                        }))
                    }
                }).catch((err) => {
                    console.log(err)
                })
        }
    }, [updates])

    useEffect(() => {
        console.log(newUpdates)
    }, [newUpdates])

    const editDashboardUser = () => {
        const body = { ...newUpdates }
        delete body.spocName
        for (const [key, value] of Object.entries(updates)) {
            if (value === body[key] && key !== 'network_center_id') {
                delete body[key]
            }
        }
        if (!Object.keys(body).length) {
            return
        }
        setIsLoading(true)
        updateDashboardUser(id, body)
            .then(() => {
                onComplete()
                onClose()
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    const updateAssigner = (key, value, toggle) => {
        setNewUpdates(u => ({ ...u, [key]: !toggle ? value : !u[key] }))
    }

    return <Modal
        visible={Boolean(id)}
        title='Edit Dashboard User'
        onCancel={onClose}
        footer={[
            <Button
                key='cancel'
                onClick={onClose}
            >
                Cancel
            </Button>,
            <Button
                key='submit'
                type='primary'
                loading={isLoading}
                onClick={editDashboardUser}
            >
                Submit
            </Button>
        ]}
    >
        <Row>
            <InputCell value={newUpdates.name} onChange={e => {
                const { value } = e.target
                updateAssigner('name', value)
            }} label='Name' />
            <Gutter />
            <InputCell value={newUpdates.userName} onChange={e => {
                const { value } = e.target
                updateAssigner('userName', value)
            }} label='User name' />
        </Row>
        <Row>
            <InputCell value={newUpdates.phone} onChange={e => {
                const { value } = e.target
                updateAssigner('phone', value)
            }} label='Phone' />
            <Gutter />
            <InputCell value={newUpdates.password} onChange={e => {
                const { value } = e.target
                updateAssigner('password', value)
            }} label='Password' placeholder='*********' />
        </Row>
        <Row>
            <InputCell value={newUpdates.email} onChange={e => {
                const { value } = e.target
                updateAssigner('email', value)
            }} label='Email' />
            <Gutter />
            <SearchSelectCell
                onChange={value => {
                    const [label, id] = value.split('-')
                    updateAssigner('spocId', Number(id))
                    updateAssigner('spocName', label)
                }}
                value={`${newUpdates.spocName}-${newUpdates.spocId}`}
                onSearch={getSpocUser}
                isLoading={isSpocLoading}
                data={spocUsers}
                label='SPOC User'
            />
        </Row>
        <Row>
            <InputCell label='Center Id(s)' onChange={e => {
                const { value } = e.target
                updateAssigner('network_center_id', value)
            }} value={newUpdates.network_center_id} />
            <Gutter />
            <SelectCell
                label='Role'
                value={newUpdates.role}
                onChange={e => {
                    const { value } = e.target
                    updateAssigner('role', value)
                }}
                options={['central', 'onsite']}
            />
        </Row>
        <Row>
            <Checkbox
                onChange={() => updateAssigner('active', undefined, true)}
                label='Active?' checked={newUpdates.active}
            />
        </Row>
        <div style={{ fontWeight: "600", marginBottom: "8px" }}>
            Center Type
        </div>
        <Row>
            <Checkbox
                onChange={() => updateAssigner('isOpdCenter', undefined, true)}
                label='Opd?' checked={newUpdates.isOpdCenter}
            />
            <Checkbox
                onChange={() => updateAssigner('isPhysioCenter', undefined, true)}
                label='Physio' checked={newUpdates.isPhysioCenter}
            />
            <Checkbox
                onChange={() => updateAssigner('isDentalCenter', undefined, true)}
                label='Dental' checked={newUpdates.isDentalCenter}
            />
        </Row>
    </Modal>
}

export default DashboardUserEditModal

const Row = props => <div
    style={{
        marginBottom: '20px', display: 'flex', flexDirection: 'row',
        justifyContent: 'space-between', alignItems: 'center'
    }}
>{props.children}</div>
const InputCell = props => <div style={{ flex: 1 }}>
    <span><strong>{props.label}</strong></span>
    <Input
        disabled={props.disabled} value={props.value}
        onChange={props.onChange} placeholder={props.placeholder}
    />
</div>
const SelectCell = props => <div style={{ flex: 1 }}>
    <span><strong>{props.label}</strong></span>
    <br />
    <select style={{
        width: '100%', border: '1px solid #d9d9d9', height: '32px', borderRadius: '4px'
    }} value={props.value} onChange={props.onChange}>
        {(props.options || []).map((opt, ind) => <option value={opt} key={ind}>
            {opt}
        </option>)}
    </select>
</div>
const Gutter = () => <div style={{ flex: .1 }} />
const Checkbox = props => <div style={{
    display: 'flex', flex: 'row', cursor: 'pointer', alignItems: 'center',
    flex: 1, alignSelf: 'flex-end'
}}>
    <input
        type='checkbox' checked={props.checked} onChange={props.onChange}
        id={props.label} style={{ marginRight: '5px', cursor: 'pointer' }}
    />
    <label style={{ cursor: 'pointer' }} htmlFor={props.label}><strong>{props.label}</strong></label>
</div>
const SearchSelectCell = props => <div style={{ flex: 1 }}>
    <span><strong>{props.label}</strong></span>
    <Select
        showSearch
        style={{
            width: '100%', border: '1px solid #d9d9d9', height: '32px', borderRadius: '4px'
        }}
        filterOption={false}
        value={props.value}
        placeholder={props.label}
        onChange={props.onChange}
        onSearch={props.onSearch}
        loading={props.isLoading}
    >
        {props.data.map(item => (
            <Select.Option key={item.value} value={`${item.label}-${item.value}`}>
                {item.label} - {item.value}
            </Select.Option>
        ))}
    </Select>
</div>